import { makeStatusOptions } from '../models/status';
import { ToggleSelectOption } from '../toggle-select/ToggleSelectOption';
import { ToggleSelect, ToggleSelectMode } from '../toggle-select/ToggleSelect';
import React from 'react';

export const StatusToggleSelect = ({ updateFilter, value }) => (
    <ToggleSelect
        mode={ToggleSelectMode.STATUS}
        children={makeStatusToggleSelectOptions(updateFilter, value)}
    />
);

const makeStatusToggleSelectOptions = (updateFilter, value) =>
    makeStatusOptions().map(option => (
        <ToggleSelectOption
            key={option.value}
            option={option}
            value={value}
            onChange={option => updateFilter(option.value)}
        />
    ));
